export default __webpack_public_path__ + "static/media/img4.0a4047c5.jpg";